import React from 'react';
import { Dialog } from '@material-ui/core';
import moment from "moment";
import DeliveryNoteForm from "./DeliveryNoteForm";
import * as Yup from "yup";
import { parseURL } from "../../../sc-utilities";

const DeliveryNoteCreate = props => {
    const { open, handleOpen, createDeliveryNote, account, activeCustomer, translations } = props;
    let activeAccount = {};
    for (var acc of account ? account : []) {
        if (acc.Deleted === false && acc.Status === 'active') {
            activeAccount = acc;
        }
    };

    const cancelHandler = () => {
        handleOpen();
    };
    let initialValues = {
        DateFrom: activeAccount ? activeAccount.LastBilledTime : null,
        DateTo: moment(),
        Billed: false,
        Accountant: account ? account.AccountantID : '',
    };
    let formSettings = {
        Validation: {
            DateFrom: Yup.date().notRequired(),
            DateTo: Yup.date().required(),
            Billed: Yup.boolean().required("Required")

        },
        FormTitle: translations['create_delivery_note'] || "Create delivery note",
        ButtonSubmit: {
            Title: translations["save"] || "SAVE",
            Color: 'primary'
        },
        ButtonCancel: {
            Title: translations["cancel"] || "CANCEL",
            handleCancel: cancelHandler
        }
    };

    const handleSubmit = async data => {
        let searchParams = parseURL(window.location.search);
        await createDeliveryNote({
            ...data,
            CustomerID: searchParams.customerID,
            LastBilledTime: account ? account.LastBilledTime : null,
            ActiveCustomerID: activeCustomer
        });
        handleOpen();
    };

    return (
        <Dialog
            open={open}
            disableBackdropClick={true}
            disableEscapeKeyDown={false}
            onClose={cancelHandler}
            fullWidth={true}
        >
            <DeliveryNoteForm
                formSettings={formSettings}
                initialValues={initialValues}
                handleSubmit={handleSubmit}
                translations={translations}
            ></DeliveryNoteForm>
        </Dialog>
    )
};

export default DeliveryNoteCreate;